import React from 'react';
import Select, { components } from 'react-select';
import ErrorMessage from '../../ErrorMessage';
import DropDownIndicator from '../../utility/DropDownIndicator';
import { userProfileCopy } from '../../../copy/advisor-dashboard/user-profile.json';

export default function SelectDropdown(props) {
  const { id, callbackFunc, list, placeholder1, placeholder2, primaryColor } =
    props;

  const errors = {
    dob: false,
    currentPassword: false,
    password: false,
    confirmPass: false,
    highSchool: false,
    somethingwentWrong: false,
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: '100%',
      borderRadius: '7px',
    }),
    option: (provided) => ({
      ...provided,
      color: primaryColor,
    }),
    input: (provided) => ({
      ...provided,
      color: primaryColor,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
      paddingLeft: '12px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
      overflow: 'visible',
      paddingLeft: '12px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: '6px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: primaryColor,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  };

  const DropdownIndicator = () => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator styles={customStyles}>
          <DropDownIndicator color={primaryColor} />
        </components.DropdownIndicator>
      )
    );
  };

  return (
    <>
      <div className="label-and-error">
        {id === 'highSchool' && (
          <span style={{ display: errors.highSchool ? '' : 'none' }}>
            <ErrorMessage error={userProfileCopy.errors.error4} />
          </span>
        )}
      </div>
      <Select
        components={DropdownIndicator}
        options={list}
        className="edit-profile-select"
        id={id}
        onChange={(e, name) => {
          callbackFunc(e, name);
        }}
        name={id}
        styles={customStyles}
        placeholder={placeholder1 || placeholder2}
        aria-label={placeholder1 || placeholder2}
      />
    </>
  );
}
